/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */

/* ===== External libraries ===== */
import { AxiosResponse, AxiosError } from 'axios';

/* ===== Shared utilities ===== */
import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService, Client } from '@umanforge/common';

/* ===== Internal modules ===== */
import { API } from 'constants/api.constant';
import { Dispatch } from '@reduxjs/toolkit';
import { GlobalService } from './global.service';

export class ClientsService {

  /* ===== Send a request to fetch all clients ===== */
  static getClients(
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Client[]> {
    return new Promise( async resolve => {
      AXIOS.get( API.CLIENT, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Client[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( client => { return { ...client }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

}
